/** Guard TabsComponent when nav buttons and panels are out of sync (e.g. building_instructions link-only tab). */
function patchTabsComponentSetAccessible() {
  const TC = customElements.get('tabs-component');
  if (!TC || TC.prototype.__wdSetAccessiblePatch) return;
  TC.prototype.__wdSetAccessiblePatch = true;
  TC.prototype.setAccessible = function () {
    const { tabNavs, tabPanels } = this.domNodes;
    if (!tabNavs?.length || !tabPanels?.length) return;
    const count = Math.min(tabNavs.length, tabPanels.length);
    for (let index = 0; index < count; index++) {
      const tab = tabNavs[index];
      const panel = tabPanels[index];
      if (tab.id) panel.setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-selected', index === 0);
      tab.setAttribute('data-index', index);
      if (panel.id) tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('tabindex', 0);
    }
  };
}

patchTabsComponentSetAccessible();

/** Switch active tab without FoxTheme panel transition (used after section swap). */
function restoreTabSelection(section, index) {
  const tabs = section.querySelector('tabs-component');
  if (!tabs || index <= 0 || typeof tabs.setActiveTab !== 'function') return;

  const instant = (fromPanel, toPanel) => {
    if (fromPanel) fromPanel.hidden = true;
    if (toPanel) toPanel.hidden = false;
  };
  const prevTransition = tabs.transition;
  const prevScroll = tabs.scrollToActiveButton;
  tabs.transition = instant;
  tabs.scrollToActiveButton = () => {};
  tabs.setActiveTab(index);
  tabs.transition = prevTransition;
  tabs.scrollToActiveButton = prevScroll;
}

TabsUpdateOnVariantChange();
function TabsUpdateOnVariantChange() {
  // load logic once
  if (window.TabsUpdateOnVariantChange_loaded)
    return;
  window.TabsUpdateOnVariantChange_loaded = true

  if (!document.querySelector('wd-product-variant-picker')) return;

  /** @type {Map<string, AbortController>} */
  const pending = new Map();

  // on variant change update the section
  document.addEventListener('variantChange', () => {

    // foreach tab section w/ update flag
    document.querySelectorAll('.section-tabs-content[product-sync="true"]').forEach((marker) => {
      const sectionId = marker.dataset.id;
      if (!sectionId) return;

      const id = `shopify-section-${sectionId}`;
      const currentSection = document.getElementById(id);
      if (!currentSection) return;

      // abort older request
      pending.get(sectionId)?.abort();
      const controller = new AbortController();
      pending.set(sectionId, controller);

      // build req
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);

      // get section
      fetch(url.toString(), { signal: controller.signal })
        .then((res) => {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then((html) => {
          // get new section
          const newSection = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
          if (!newSection) throw new Error('empty');

          const selectedTab = currentSection.querySelector('.tabs__tab[aria-selected="true"]');
          const selectedIndex = Number(selectedTab?.dataset.index ?? 0);

          currentSection.replaceWith(newSection);
          restoreTabSelection(newSection, selectedIndex);

          // ensure theme editor updated
          newSection.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        })
        .catch((err) => {
          // ignore abort errors
          if (err?.name === 'AbortError') return;

          // hide section
          currentSection.hidden = true;
        })
        .finally(() => {
          // cleanup abort controller
          if (pending.get(sectionId) === controller)
            pending.delete(sectionId);
        });
    });
  });
}
